import { FC } from 'react';

import {
    ArrowClockwiseIcon,
    BackArrowIcon,
    BroadcastIcon,
    CameraIcon,
    CaretDownIcon,
    CaretLeftIcon,
    CaretRightIcon,
    CaretUpIcon,
    ChartLineIcon,
    CheckCircleIcon,
    CheckIcon,
    CloseIcon,
    ClubIcon,
    CollapseIcon,
    ComparisonIcon,
    CopyIcon,
    ExpandIcon,
    FilterIcon,
    GoalIcon,
    GolfIcon,
    IconProps,
    MenuIcon,
    MinusIcon,
    PauseIcon,
    PencilCircleIcon,
    PencilIcon,
    PlayIcon,
    PlusCircleIcon,
    PlusIcon,
    ProhibitIcon,
    RepeatIcon,
    StarIcon,
    TargetIcon,
    ThreeDIcon,
    TrashIcon,
} from '../icons';

type IconConfig = { component: FC<IconProps>; defaultSize: number };

export const availableIcons = {
    close: { component: CloseIcon, defaultSize: 14 },
    filter: { component: FilterIcon, defaultSize: 14 },
    'chart-line': { component: ChartLineIcon, defaultSize: 14 },
    minus: { component: MinusIcon, defaultSize: 14 },
    plus: { component: PlusIcon, defaultSize: 14 },
    expand: { component: ExpandIcon, defaultSize: 16 },
    collapse: { component: CollapseIcon, defaultSize: 16 },
    'plus-circle': { component: PlusCircleIcon, defaultSize: 18 },
    pencil: { component: PencilIcon, defaultSize: 18 },
    'pencil-circle': { component: PencilCircleIcon, defaultSize: 24 },
    camera: { component: CameraIcon, defaultSize: 18 },
    threed: { component: ThreeDIcon, defaultSize: 18 },
    target: { component: TargetIcon, defaultSize: 14 },
    club: { component: ClubIcon, defaultSize: 14 },
    'arrow-clockwise': { component: ArrowClockwiseIcon, defaultSize: 14 },
    checkmark: { component: CheckIcon, defaultSize: 18 },
    'checkmark-circle': { component: CheckCircleIcon, defaultSize: 18 },
    'caret-left': { component: CaretLeftIcon, defaultSize: 18 },
    'caret-right': { component: CaretRightIcon, defaultSize: 18 },
    'caret-down': { component: CaretDownIcon, defaultSize: 18 },
    'caret-up': { component: CaretUpIcon, defaultSize: 18 },
    star: { component: StarIcon, defaultSize: 18 },
    goal: { component: GoalIcon, defaultSize: 16 },
    menu: { component: MenuIcon, defaultSize: 16 },
    comparison: { component: ComparisonIcon, defaultSize: 14 },
    trash: { component: TrashIcon, defaultSize: 14 },
    repeat: { component: RepeatIcon, defaultSize: 14 },
    back: { component: BackArrowIcon, defaultSize: 14 },
    play: { component: PlayIcon, defaultSize: 14 },
    pause: { component: PauseIcon, defaultSize: 14 },
    prohibit: { component: ProhibitIcon, defaultSize: 14 },
    golf: { component: GolfIcon, defaultSize: 14 },
    broadcast: { component: BroadcastIcon, defaultSize: 14 },
    copy: { component: CopyIcon, defaultSize: 14 },
} satisfies Record<string, IconConfig>;

export const availableIconSizes = {
    tiny: 12,
    small: 14,
    medium: 16,
    large: 18,
    extraLarge: 24,
};
